import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueApexCharts from 'vue-apexcharts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { DataTables } from 'vue-data-tables'
import App from './App.vue'
import router from './router'
import store from './store'

import FloatingLabel from '@/directives/floating-label'
import setContentHeight from '@/directives/set-content-height'
import fileInput from '@/directives/file-input'
// import changeStatus from '@/directives/change-status'

Vue.use(Vuelidate)
Vue.use(VueApexCharts)
Vue.use(ElementUI)
locale.use(lang)
Vue.use(DataTables)

Vue.config.productionTip = false

Vue.directive('floating-label', FloatingLabel)
Vue.directive('set-content-height', setContentHeight)
Vue.directive('file-input', fileInput)
// Vue.directive('change-status', changeStatus)

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
